import Vue from 'vue'
import ESvgIcon from '~/components/elements/icons/e-svg-icon'

Vue.component('ESvgIcon', ESvgIcon)
